export const EVENT_BUS_PORT_NAME = 'event_bus_port';
